// src/components/gestionEvento/formsAjustes/RedesSocialesForm.js

import React from 'react';
import PropTypes from 'prop-types'; // Importar PropTypes
import { Grid, TextField, Box } from '@mui/material';

const RedesSocialesForm = ({
  formData = {}, // Valor por defecto
  onChange,      // Recibe handleChangeSocial
}) => {
  const sectionSx = {
    '& .MuiOutlinedInput-root': { borderRadius: 2 },
  };

  return (
    <Grid container spacing={2} disableEqualOverflow sx={sectionSx}>
      {/* Facebook */}
      <Grid item xs={12} sm={6}>
        <TextField
          label="Facebook URL"
          name="facebook" // Corresponde a la clave en formData.social
          type="url"     // Tipo URL
          fullWidth
          value={formData.facebook ?? ''} // Acceso seguro
          onChange={(e) => onChange(e.target.name, e.target.value)}
          placeholder="https://facebook.com/tu_pagina"
          variant="outlined" // Especificar variante
        />
     </Grid>

      {/* Instagram */}
      <Grid item xs={12} sm={6}>
        <TextField
          label="Instagram URL"
          name="instagram"
          type="url"
          fullWidth
          value={formData.instagram ?? ''}
          onChange={(e) => onChange(e.target.name, e.target.value)}
          placeholder="https://instagram.com/tu_perfil"
          variant="outlined"
        />
     </Grid>

      {/* Twitter */}
      <Grid item xs={12} sm={6}>
        <TextField
          label="Twitter (X) URL" // Actualizar label si se desea
          name="twitter"
          type="url"
          fullWidth
          value={formData.twitter ?? ''}
          onChange={(e) => onChange(e.target.name, e.target.value)}
          placeholder="https://x.com/tu_perfil"
          variant="outlined"
        />
     </Grid>

      {/* WhatsApp */}
      <Grid item xs={12} sm={6}>
        <TextField
          label="Grupo de WhatsApp URL"
          name="whatsapp"
          type="url" // Aunque también podría ser un número, URL es común para grupos
          fullWidth
          value={formData.whatsapp ?? ''}
          onChange={(e) => onChange(e.target.name, e.target.value)}
          placeholder="https://chat.whatsapp.com/..."
          variant="outlined"
        />
     </Grid>

      {/* Sitio Web */}
      <Grid item xs={12} sm={6}>
        <TextField
          label="Sitio Web"
          name="sitioWeb"
          type="url"
          fullWidth
          value={formData.sitioWeb ?? ''}
          onChange={(e) => onChange(e.target.name, e.target.value)}
          placeholder="https://tu-sitio.com"
          variant="outlined"
        />
     </Grid>
    </Grid>
  );
};

// Definir PropTypes
RedesSocialesForm.propTypes = {
  formData: PropTypes.shape({
    facebook: PropTypes.string,
    instagram: PropTypes.string,
    twitter: PropTypes.string,
    whatsapp: PropTypes.string,
    sitioWeb: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
};

export default RedesSocialesForm;
